import mediasMixin from 'root/mixins/mediasMixin.js'
import utilsMixin from 'root/mixins/utilsMixin.js';

export default {
  name: 'all-brands-banners',
  mixins: [mediasMixin, utilsMixin],
  props :['data'],
  data () {
    return {
      lodash: _
    }
  },

  methods: {
    getBanner(brandBanner) {
      return _.find(brandBanner.firstBanner, (banner) => {
        return banner.format == (this.ismobile ? 'mobile' : (this.istable ? 'tablet' : 'desktop'));
      });
    },
    getBannerSrc(brandBanner) {
      return _.get(this.getBanner(brandBanner), "url", "");
    },
    getBannerAlt(brandBanner) {
      return _.get(this.getBanner(brandBanner), "altText", "");
    },
  },
  
  computed: {
    parsedData: function() {
      return this.isJson(this.encodeCustomQuotes(this.data));
    },
    brandBannerList() {
      return _.get(this, "parsedData.brandBannerList", []);
    },
    maxBannersPerRow() {
      return this.ismobile ? _.get(this, "parsedData.maxBannersPerRowMobile") : _.get(this, "parsedData.maxBannersPerRowDesktop");
    },
  },
  
  mounted() {
    
  }

}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/allbrandsbanners/allbrandsbanners.js